// extracted by mini-css-extract-plugin
export var auto = "_2q-1";
export var spinner = "_2q-0";